export type AttachmentInfo = {
  fileName: string;
  url?: string;
  id: number;
  isFinalReport?: boolean;
};

export type ValidContract = {
  abbContractNumber?: string;
  userContractNumber?: string;
  type: 0 | 1 | 2;
  startDate: string; // ISO 8601 (UTC Z)
  endDate: string; // ISO 8601 (UTC Z)
  validity: string; // e.g., "Valid"
  documents: (string | null)[];
  rootEquipments: string[];
  site: string;
  contractId: string;
  author?: string;
};

export type GetValidContractsResponse = ValidContract[];

export type SupportLineTermsSection = {
  title: string;
  body: string;
};

export type SupportLineTermsAndConditions = {
  version: string;
  validFrom: string; // ISO 8601 date
  sections: SupportLineTermsSection[];
};

export type CallSetupInfo = {
  userId: string;
  token: string;
  expiresOn: string;
  phoneFrom: string;
  phoneTo: string;
};

export enum SupportTicketStatus {
  Open = 0,
  InProgress = 1,
  OnHold = 2,
  Resolved = 3,
  Closed = 4,
}

export enum SupportTicketType {
  EngineeringTicket = 0,
  SupportLineCase = 1,
}

export enum PreferredContactChannel {
  PhoneCall = 0,
  InApp = 1,
}

export type SalesforceCaseDetails = {
  caseId: string;
  subject?: string | null;
  description?: string | null;
  contactEmail?: string | null;
  status?: string | null;
  createdDate?: string | null;
  [field: string]: unknown;
};

export type SiteRootEquipmentSelection = {
  site: string;
  rootEquipments: string[];
}[];

export type SupportTicketTData = {
  type: SupportTicketType;
  id: number;
  ticketNumber: string;
  customer: string;
  rootEquipment: string;
  equipment: string;
  subject: string;
  description: string;
  requestedBy: string;
  contactEmail: string;
  contactPhone: string;
  preferredContactChannel?: PreferredContactChannel;
  status: SupportTicketStatus;
  contractNumber: string;
  eventDateTime: string;
  timeSpentInMins?: number;
  potentialSuccessStory?: boolean | null;
  estimatedDowntimeSavedHours?: number | null;
  createdAt: string;
  attachments: AttachmentInfo[];
  externalId: string;
  accepted: boolean;
  summary?: string;
  site?: string;
  siteTimeZone?: string | null;
};
export type EditSupportTicketDto = {
  equipment?: string;
  subject?: string;
  description?: string;
  requestedBy?: string;
  contactEmail?: string;
  contactPhone?: string;
  status?: SupportTicketStatus;
  contractNumber?: string;
  eventDateTime?: string;
  timeSpentInMins?: number;
  potentialSuccessStory?: boolean | null;
  estimatedDowntimeSavedHours?: number | null;
  externalId?: string;
};

export type UploadSupportLineFileDto = {
  ticketNumber: string;
  file: File;
};

/** Date-times are local "yyyy-MM-ddTHH:mm" values as written in the report. */
export type FinalReportImportResult = {
  subject?: string | null;
  description?: string | null;
  eventDateTime?: string | null;
  closedDateTime?: string | null;
  contactEmail?: string | null;
  contactPhone?: string | null;
  requestedBy?: string | null;
  contractNumber?: string | null;
  timeSpentInMins?: number | null;
  equipment?: string | null;
  caseLogs: {
    dateTime: string;
    event: string;
    channel?: string | null;
    from?: string | null;
    to?: string | null;
    notes?: string | null;
  }[];
};

export type CaseLogEntry = {
  id: number;
  event: string;
  dateTime: string;
  channel: string;
  from: string;
  to: string;
  notes: string;
};

export type CaseLogKpi = {
  firstResponseMinutes: number | null;
  solutionDeliveryMinutes: number | null;
  caseResolutionMinutes: number | null;
};
